import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Login from '@/components/Login'
import ProjectList from '@/components/Choose'
import Device from '@/components/Devices/Index'
import CCH from '@/components/Devices/CCH'
import Setup from '@/components/Devices/Setup'
import Log from '@/components/Devices/Log'
import Report from '@/components/Report/Report'
import CCHReport from '@/components/Report/CCHReport'
import Pandect from '@/components/Report/Pandect'
import AdminDealer from '@/components/Admin/AdminDealer'
import DealerAdd from '@/components/Admin/DealerAdd'
import DealerEdit from '@/components/Admin/DealerEdit'
import AccountAdd from '@/components/Admin/AccountAdd'
import passwordEdit from '@/components/Admin/passwordEdit'
import School from '@/components/School/Index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Index',
      component: Login
    },
    {
      path: '/School',
      name: 'School',
      component: School
    },
    {
      path: '/Choose',
      name: 'ProjectList',
      component: ProjectList
    },
    {
      path: '/Pandect',
      name: 'Pandect',
      component: Pandect
    },
    {
      path: '/AdminDealer',
      name: 'AdminDealer',
      component: AdminDealer
    },
    {
      path: '/DealerAdd',
      name: 'DealerAdd',
      component: DealerAdd
    },
    {
      path: '/DealerEdit',
      name: 'DealerEdit',
      component: DealerEdit
    },
    {
      path: '/AccountAdd',
      name: 'AccountAdd',
      component: AccountAdd
    },
    {
      path: '/passwordEdit',
      name: 'passwordEdit',
      component: passwordEdit
    },
    {
      path: '/Detail',
      name: 'Detail',
      component: Index,
      children: [{
        path:'',
        components: {
          real:Device,
          cch:CCH,
          report: Report,
          cchreport:CCHReport,
          setup:Setup,
          log:Log
        }
      },{
        path:'Device',
        name:'Device',
        components: {
          real:Device,
          cch:CCH,
          report: Report,
          cchreport:CCHReport,
          setup:Setup,
          log:Log
        }
      },]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js